import { useLazyQuery, useMutation } from "@apollo/client";
import useReactRouter from "use-react-router";
import { faCheckCircle, faCircleDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { COLOR_APP, COMMISSION_OFFICE, IMAGE_4B, S3_URL } from "../../../constants";
import { GET_ORDERGROUPS_DETAIL } from "../../../graphql/order/query";
import { calculateRoundedValue, imageRender } from "../../../helpers";
import OrderGroupDetail from "./OrderGroupDetail";
import LOGO_IMAGE from "../../../image/IMG_6030.JPG";
import ShopInfoOrderConfirm from "./ShopInfoOrderConfirm";
import AnimationLoading from "../../../components/AnimationLoading";
import FinishOrder from "./FinishOrder";
import { GET_BANKS } from "../../../graphql/bank/query";
import { GET_SETTINGS } from "../../../graphql/setting/query";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {
    Tab,
    Tabs,
    Form,
    Modal,
    Button,
    Spinner,
    Alert,
} from "react-bootstrap";
import { PAYMENT_WITH_LIVE_STOCKS } from "../../../graphql/order/mutation";
import { GET_USER_CONFIRMS } from "../../../graphql/userConfirm/query";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { GET_EXCHANGRATE } from "../../../graphql/exchangeRate/Query";
import { SiAmazonpay } from "react-icons/si";
import CustomNavbar from "../../../components/CustomNavbar";
import ConfirmClaimBalance from "./ConfirmClaimBalance";


function ClaimBalance() {
    const { history, match, location } = useReactRouter();

    const [getBankData, { data: bankData }] = useLazyQuery(GET_BANKS, {
        fetchPolicy: "cache-and-network",
    });
    const [getShopSetting, { data: shopSettingData }] = useLazyQuery(
        GET_SETTINGS,
        { fetchPolicy: "cache-and-network" }
    );
    const [getOrderData, { data: _orderData, loading: _orderLoading }] =
        useLazyQuery(GET_ORDERGROUPS_DETAIL, { fetchPolicy: "cache-and-network" });

    const [confirmOrderGroups, { loading: loadingConfirmOrder }] = useMutation(
        PAYMENT_WITH_LIVE_STOCKS
    );
    const [getUserConfirms, { data: userConfirmDatas }] =
        useLazyQuery(GET_USER_CONFIRMS);
    const [getExchangeRate, { data: loadExchangeRate }] = useLazyQuery(
        GET_EXCHANGRATE,
        { fetchPolicy: "cache-and-network" }
    );

    // State
    const { width, height } = useWindowDimensions()
    const [orderData, setOrderData] = useState();
    const [firsStep, setFirstStep] = useState(true);
    const [secondStep, setSecondStep] = useState(false);
    const [lastStep, setLastStep] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [isAlert, setIsAlert] = useState(false);
    const [commission, setCommission] = useState(null)
    const [shopId, setShopId] = useState()
    const [shopRate, setShopRate] = useState()

    useEffect(() => {
        getExchangeRate({
            variables: {
                where: {
                    shop: shopId,
                },
            },
        });
    }, [shopId]);

    useEffect(() => {
        if (match?.params?.data) {
            let matchData = match?.params?.data.split("&&");
            getLiveOrder(matchData[0], matchData[1]);
        }
    }, [match?.params?.data]);

    useEffect(() => {
        if (_orderData?.orderGroup) {
            _fetchShopSetting(_orderData?.orderGroup?.shop?.id);
            _fetchBank(_orderData?.orderGroup?.shop?.id);
            setOrderData(_orderData?.orderGroup);
            setCustomerName(_orderData?.orderGroup?.cfName);
            setAddress(_orderData?.orderGroup?.addressCf);
            setPhone(_orderData?.orderGroup?.phone);
            setShopId(_orderData?.orderGroup?.shop?.id)
        }
        if (_orderData?.orderGroup?.phone && _orderData?.orderGroup?.paySlip) {
            setSecondStep(true);
            setLastStep(true);
        }
    }, [_orderData]);

    // get user comfirm
    useEffect(() => {
        if (orderData) {
            setCustomerName(
                orderData?.customerName != "" && orderData?.customerName
                    ? orderData?.customerName
                    : orderData?.cfName ?? ""
            );

            getUserConfirms({
                variables: {
                    where: {
                        psid: orderData?.userFbId
                    },
                    orderBy: "createdAt_DESC"
                },
            });
        }
    }, [orderData]);

    useEffect(() => {
        if (userConfirmDatas?.userConfirms?.data) {
            const customerJsonData = localStorage.getItem('CUSTOMER_DATA');
            let customerData = {};
            if (customerJsonData) {
                customerData = JSON.parse(customerJsonData)
            }
            setPhone(customerData?.phone || userConfirmDatas?.userConfirms?.data[0]?.phone);
            setAddress(customerData?.addressCF || userConfirmDatas?.userConfirms?.data[0]?.addressCF)
        }
    }, [userConfirmDatas])

    useEffect(() => {
        if (loadExchangeRate?.exchangeRate) {
            setShopRate(loadExchangeRate?.exchangeRate)
        }
    }, [loadExchangeRate])


    const getLiveOrder = async (_liveId, _userFbId) => {
        try {
            getOrderData({
                variables: {
                    where: {
                        // live: _liveId,
                        // cfName: _userFbId,
                        // userFbId: _userFbId,
                        id: _liveId,
                        // isDeleted: false
                    },
                    orderBy: "createdAt_DESC",
                },
            });
        } catch (error) {
            console.log("Error retrieving posts", error);
        }
    };

    const _fetchShopSetting = async (shopId) => {
        getShopSetting({
            variables: {
                where: { shop: shopId },
                orderBy: "createdAt_ASC",
            },
        });
    };

    const _fetchBank = async (shopId) => {
        try {
            getBankData({
                variables: {
                    where: {
                        shop: shopId,
                        isDeleted: false,
                    },
                    skip: 0,
                    limit: 100,
                    orderBy: "createdAt_DESC",
                },
            });
        } catch (err) {
            console.log(err);
        }
    };

    const onConfirmForClient = async () => {
        try {
            if (!phone) {
                setIsAlert(true);
                return;
            }
            if (!address) {
                setIsAlert(true);
                return;
            }
            if (loadingConfirmOrder) return;
            localStorage.setItem(
                "CUSTOMER_DATA",
                JSON.stringify({
                    name: customerName,
                    phone: phone,
                    addressCF: address,
                })
            );
            setIsAlert(false);

            let _price = orderData?.totalPrice;

            let priceProduct = 0;

            if (commission !== null) {
                priceProduct = _price + (_price * commission) / 100;
            } else {
                priceProduct = _price;
            }


            let priceToPaid = await calculateRoundedValue(priceProduct / 1000) * 1000;

            const response = await confirmOrderGroups({
                variables: {
                    data: {
                        // amount: priceToPaid, // production
                        amount: 1, // dev test
                        psid: orderData?.userFbId,
                        orderGroup: {
                            id: orderData?.id,
                            customerName: customerName,
                            phone: phone,
                            addressCf: address,
                            logistic: address,
                            shop: orderData?.shop?.id,
                            shopName: orderData?.shop?.name,
                        },
                    },
                },
            });

            if (response) {
                let _response = JSON.parse(response?.data?.paymentWithLiveStocks?.data);
                // console.log(_response);
                // setIsLink(true);
                // setRedirecUrl(_response.redirectURL);
                window.open(_response.redirectURL, "_blank");
                setIsAlert(false);
            }
        } catch (error) {
            console.log(error);
            setIsAlert(false);
        }
    };


    // on selelct mode of payment 
    const onModePayment = async (e) => {
        if (e === "payment-support") {
            setCommission(2)
        } else {

            setCommission(null)
        }
    }

    console.log("orderData::::", orderData)


    if (_orderLoading) return <LoadingSpinner />;

    return (
        <>
            <CustomNavbar phone={orderData?.shop?.phone} />
            <div
                style={{
                    background: "#F5F5FA",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    paddingTop: '4em'
                }}
            >

                <div style={{ width: width > 700 ? "50vw" : "100%", background: '#ffffff', padding: 5, }}>
                    <div style={{ display: "flex", width: "100%", }}>
                        <img
                            src={imageRender(orderData?.shop?.image)}
                            style={{
                                width: 100,
                                marginTop: 5,
                                marginLeft: 5,
                                height: 100,
                                borderRadius: ".5em",
                            }}
                        />
                        <div
                            style={{ display: "flex", flexDirection: "column", marginLeft: 10 }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "68vw",
                                    fontWeight: 'bold'
                                }}
                            >
                                ຮ້ານ: {orderData?.shop?.name}
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "68vw",
                                }}
                            >
                                ເພຈ: {orderData?.live?.pageName ?? orderData?.post?.pageName}
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "68vw",
                                }}
                            >
                                ເບີໂທ: {orderData?.shop?.phone}
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    fontSize: 12,
                                }}
                            >
                                ທີ່ຢູ່: {orderData?.shop?.address?.village},{" "}
                                {orderData?.shop?.address?.district},{" "}
                                {orderData?.shop?.address?.province}
                            </div>
                        </div>
                    </div>

                    <OrderGroupDetail
                        orderData={orderData}
                        commission={commission === 2 ? commission : null}
                        shopRate={shopRate}
                        setSecondStep={setSecondStep}
                        isPaymented={orderData?.isPaymented}
                    />


                    {orderData?.isPaymented ? (
                        (orderData?.status === "PAYMENT_STILL_INCOMPLETE" || orderData?.status === "IMAGE_NOT_YET_PAID" || orderData?.status === "CREATED") ? (
                            <div style={{ width: "100%" }}>
                                <div style={{ fontWeight: "bold", fontSize: 20, textAlign: "center", paddingTop: 10 }}>
                                    ຊ່ອງທາງການຊຳລະ
                                </div>
                                <ConfirmClaimBalance
                                    setSecondStep={setSecondStep}
                                    setLastStep={setLastStep}
                                    orderData={orderData}
                                    shopSettingData={shopSettingData}
                                    bankData={bankData}
                                    isPaymented={orderData?.isPaymented}
                                    status={orderData?.status}
                                />

                            </div>
                        ) : (
                            <p className="d-flex justify-content-center align-items-center w-100 pt-4">ຂອບໃຈຫຼາຍໆ ທີ່ລູກຄ້າມາຊ່ວຍອຸດໜູນ</p>
                        )
                    ) : (

                        <div style={{ width: "100%" }}>
                            <div style={{ fontWeight: "bold", fontSize: 20, textAlign: "center", paddingTop: 10 }}>
                                ຊ່ອງທາງການຊຳລະ
                            </div>
                            <ConfirmClaimBalance
                                setSecondStep={setSecondStep}
                                setLastStep={setLastStep}
                                orderData={orderData}
                                shopSettingData={shopSettingData}
                                bankData={bankData} 
                            />

                        </div>

                    )}





                </div>
            </div>

        </>
    );
}

export default ClaimBalance;
